import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { Interceptors } from './core/OpenAPI';
import { AxiosHttpRequest } from './core/AxiosHttpRequest';

import { BulkUploadsService } from './services.gen';
import { ChasesService } from './services.gen';
import { DefaultService } from './services.gen';
import { ManualUploadFilesService } from './services.gen';
import { RmBasicFileUploadsService } from './services.gen';
import { RmGeneralFileUploadsTagService } from './services.gen';
import { RmStandardFileUploadsService } from './services.gen';

type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;

export class GeneratedRequestManagerApiClient {

	public readonly bulkUploads: BulkUploadsService;
	public readonly chases: ChasesService;
	public readonly default: DefaultService;
	public readonly manualUploadFiles: ManualUploadFilesService;
	public readonly rmBasicFileUploads: RmBasicFileUploadsService;
	public readonly rmGeneralFileUploadsTag: RmGeneralFileUploadsTagService;
	public readonly rmStandardFileUploads: RmStandardFileUploadsService;

	public readonly request: BaseHttpRequest;

	constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = AxiosHttpRequest) {
		this.request = new HttpRequest({
			BASE: config?.BASE ?? '',
			VERSION: config?.VERSION ?? '0.1.0',
			WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
			CREDENTIALS: config?.CREDENTIALS ?? 'include',
			TOKEN: config?.TOKEN,
			USERNAME: config?.USERNAME,
			PASSWORD: config?.PASSWORD,
			HEADERS: config?.HEADERS,
			ENCODE_PATH: config?.ENCODE_PATH,
			interceptors: {
				request: config?.interceptors?.request ?? new Interceptors(),
				response: config?.interceptors?.response ?? new Interceptors(),
      },
		});

		this.bulkUploads = new BulkUploadsService(this.request);
		this.chases = new ChasesService(this.request);
		this.default = new DefaultService(this.request);
		this.manualUploadFiles = new ManualUploadFilesService(this.request);
		this.rmBasicFileUploads = new RmBasicFileUploadsService(this.request);
		this.rmGeneralFileUploadsTag = new RmGeneralFileUploadsTagService(this.request);
		this.rmStandardFileUploads = new RmStandardFileUploadsService(this.request);
	}
}
